/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Screen_Switch_LabelInputs */

const vi_station_screen_switch_label = /** @type {(inputs: Station_Screen_Switch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển màn`)
};

/**

* @param {Station_Screen_Switch_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_screen_switch_label = /** @type {((inputs?: Station_Screen_Switch_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Screen_Switch_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_screen_switch_label(inputs)
});